export interface BatchTrcBooksAndAvRegRequest {
  startNumFrom: string
  startNumTo: string
  rdoMarcType: string
  rdoMarcSearchType: string
  rdoMarcAlreadyExists: string
  isTenkyoReplace: boolean
  isMaterialFormatFitTargetUser: boolean
  isNotCollectionReplace: boolean
  collectionForm: string
  newPublicationDate: string
  rdoBunrui: string
  isHyoukiZenkaku: boolean
  isKanaHankaku: boolean
  rdoTraderDonor: string
  traderType: string
  donorType: string
  acceptDate: string
  acceptType: string
  budgetYear: string
  budgetBranch: string
  budgetDepartment: string
  expenseCode: string
  equipmentConsumptionCode: string
  rdoPrice: string
  isCalcPrice: boolean
  collectionStatus: string
  branchCode: string
  shelfType: string
  collectionType: string
  department: string
  handlingType: string
  storeCode: string
  appendixCode: string
  isCheckDigit: boolean
  inputFileMarc: string
  memo: string
  trcBellNewOrderRegistrationFlag: boolean
  batchType: string
}

export function BatchTrcBooksAndAvRegRequestToJSON(
  value: BatchTrcBooksAndAvRegRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    rdo_marc_type: value.rdoMarcType,
    rdo_marc_search_type: value.rdoMarcSearchType,
    rdo_marc_already_exists: value.rdoMarcAlreadyExists,
    is_tenkyo_replace: value.isTenkyoReplace,
    is_material_format_fit_target_user: value.isMaterialFormatFitTargetUser,
    is_not_collection_replace: value.isNotCollectionReplace,
    collection_form: value.collectionForm,
    new_publication_date: value.newPublicationDate,
    rdo_bunrui: value.rdoBunrui,
    is_hyouki_zenkaku: value.isHyoukiZenkaku,
    is_kana_hankaku: value.isKanaHankaku,
    rdo_trader_donor: value.rdoTraderDonor,
    trader_type: value.traderType,
    donor_type: value.donorType,
    accept_date: value.acceptDate,
    accept_type: value.acceptType,
    budget_year: value.budgetYear,
    budget_branch: value.budgetBranch,
    budget_department: value.budgetDepartment,
    expense_code: value.expenseCode,
    equipment_consumption_code: value.equipmentConsumptionCode,
    rdo_price: value.rdoPrice,
    is_calc_price: value.isCalcPrice,
    collection_status: value.collectionStatus,
    branch_code: value.branchCode,
    shelf_type: value.shelfType,
    collection_type: value.collectionType,
    department: value.department,
    handling_type: value.handlingType,
    store_code: value.storeCode,
    appendix_code: value.appendixCode,
    is_check_digit: value.isCheckDigit,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    trc_bell_new_order_registration_flag: value.trcBellNewOrderRegistrationFlag,
    batch_type: value.batchType
  }
}
